import { create } from 'zustand';
import type { IAppointmentConfig } from '@bb/domain/dist/types';

interface IAppointmentConfigStore {
  appointmentConfigPromises: Record<string, Promise<IAppointmentConfig>>;
  setAppointmentConfigPromise: (
    listingId: string,
    appointmentConfigPromise: Promise<IAppointmentConfig>,
  ) => void;
  invalidateAppointmentConfigCache: (listingId?: string) => void;
}

export const zustandAppointmentConfigStore = create<IAppointmentConfigStore>(
  set => ({
    appointmentConfigPromises: {},
    setAppointmentConfigPromise: (
      listingId,
      appointmentConfigPromise,
    ): void => {
      set(state => ({
        appointmentConfigPromises: {
          ...state.appointmentConfigPromises,
          [listingId]: appointmentConfigPromise,
        },
      }));
    },
    invalidateAppointmentConfigCache: (listingId): void => {
      if (!listingId) {
        set({ appointmentConfigPromises: {} });
        return;
      }

      set(state => {
        const { [listingId]: _removed, ...appointmentConfigPromises } =
          state.appointmentConfigPromises;
        return { appointmentConfigPromises };
      });
    },
  }),
);
